/**
 * Hub's own meetings. Google Meet and Zoom are connectors that fill this shape.
 */

export type HubMeetingSystemId = "hub" | "google" | "zoom";

export type HubMeetingStatus = "live" | "upcoming" | "past";

export type HubMeeting = {
  id: string;
  title: string;
  start: string | null;
  end: string | null;
  joinUrl?: string;
  status: HubMeetingStatus;
  system: HubMeetingSystemId;
  accountEmail?: string;
  attendees?: string[];
  location?: string;
};

export function meetingSystemLabel(system: HubMeetingSystemId): string {
  if (system === "google") return "Google Meet";
  if (system === "zoom") return "Zoom";
  return "Hub";
}

export function meetingStatusLabel(status: HubMeetingStatus): string {
  if (status === "live") return "Live";
  if (status === "past") return "Ended";
  return "Upcoming";
}
